export const NO_CROSS_TOKEN_CODE = 'NO_CROSS_TOKEN';

const isPlainObject = (value) => !!value && typeof value === 'object' && !Array.isArray(value);

const filledText = (value) => (typeof value === 'string' && value ? value : null);

export const normalizeEnvelope = (body) => {
  const wrapped = isPlainObject(body) && Object.prototype.hasOwnProperty.call(body, 'data');
  const source = wrapped ? body : { data: body };
  const coverage = isPlainObject(source.coverage) ? source.coverage : {};
  return {
    state: filledText(source.state),
    stateReason: filledText(source.stateReason) || filledText(source.unavailableReason),
    asOf: typeof source.asOf === 'string' ? source.asOf : null,
    isPartial: source.isPartial === true,
    definitionVersion: typeof source.definitionVersion === 'number' ? source.definitionVersion : null,
    coverage: {
      collectionStartedAt: coverage.collectionStartedAt || null,
      backfilledFrom: coverage.backfilledFrom || null,
      measuredFrom: coverage.measuredFrom || null,
    },
    notes: Array.isArray(source.notes) ? source.notes.filter((note) => typeof note === 'string' && note) : [],
    data: source.data === undefined ? null : source.data,
  };
};

const statusOf = (error) => (error && error.response && typeof error.response.status === 'number' ? error.response.status : null);

const serverMessage = (error) => {
  const data = error && error.response && error.response.data;
  const message = data && typeof data === 'object' ? data.message : null;
  return typeof message === 'string' && message.length <= 200 ? message : null;
};

export const classifyError = (error) => {
  const status = statusOf(error);
  if (error && error.code === NO_CROSS_TOKEN_CODE) return { kind: 'session', status: null };
  if (status === 404) return { kind: 'disabled', status: status };
  if (status === 401 || status === 403) return { kind: 'forbidden', status: status };
  if (status === 400) return { kind: 'invalid', status: status, message: serverMessage(error) };
  return { kind: 'failed', status: status };
};

export const errorMessage = (error, action) => {
  const info = classifyError(error);
  if (info.kind === 'session') return 'Saia e entre novamente no Master para autenticar na API v2.';
  if (info.kind === 'disabled') return 'O Product Intelligence está desligado ou ainda não foi publicado neste ambiente (404).';
  if (info.kind === 'forbidden') return 'Sem permissão (' + info.status + '). É necessário um usuário operador da plataforma.';
  if (info.kind === 'invalid') return info.message || 'Filtro inválido para esta consulta (400). Revise o período e os filtros.';
  return 'Não foi possível ' + (action || 'carregar os dados') + (info.status ? ' (' + info.status + ')' : '') + '.';
};

export const describeError = (error, action) => {
  const info = classifyError(error);
  return {
    kind: info.kind,
    status: info.status,
    message: errorMessage(error, action),
    retryable: info.kind === 'failed',
  };
};



// WEBPACK FOOTER //
// ./src/vue/pages/components/pi/piEnvelope.js